export default __webpack_public_path__ + "static/media/logo.fdd0fc4e.svg";